export const normalizePhone = (phone: string): number =>
  Number(phone.replace(/[^0-9]/g, ''))